import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

firebase.initializeApp({
    apiKey: 'AIzaSyB8HSe4Elg6GP2kD2ENKlFG9QsLXIMTv88',
    authDomain: 'limber-staging-193214.firebaseapp.com',
    databaseURL: 'https://limber-staging-193214.firebaseio.com',
    projectId: 'limber-staging-193214',
    storageBucket: 'limber-staging-193214.appspot.com',
    messagingSenderId: '257142263578'
}, 'staging');

firebase.initializeApp({
    apiKey: 'AIzaSyAMSr5sCNqfFmAd6OZqD-YlI7PbUm5hZ0g',
    authDomain: 'limber-live.firebaseapp.com',
    databaseURL: 'https://limber-live.firebaseio.com',
    projectId: 'limber-live',
    storageBucket: 'limber-live.appspot.com',
    messagingSenderId: '111960222001'
}, 'live');

firebase.initializeApp({
    apiKey: "AIzaSyBzsrFXACfwkUXrq_Y9jYYwvkE6cna4Lu4",
    authDomain: "limber-devops.firebaseapp.com",
    databaseURL: "https://limber-devops.firebaseio.com",
    projectId: "limber-devops",
    storageBucket: "limber-devops.appspot.com",
    messagingSenderId: "733583921287",
}, 'devops');

Promise.all([
    waitForFirebaseInit('staging'),
    waitForFirebaseInit('live'),
    waitForFirebaseInit('devops')
]).then(() => {
    const db = firebase.app('devops').firestore();
    db.settings({
        timestampsInSnapshots: true
    });
    ReactDOM.render(<App/>, document.getElementById('root'));
});

function waitForFirebaseInit(appName) {
    return new Promise((resolve) => {
        const unsub = firebase.app(appName).auth().onAuthStateChanged(() => {
            unsub();
            resolve();
        });
    });
}



// WEBPACK FOOTER //
// ./src/index.js